import React from 'react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '../components/ui/accordion';
import { useLanguage } from '../context/LanguageContext';
import translations from '../translations';

const FAQSection = () => {
  const { lang, t } = useLanguage();
  const faqs = translations[lang]?.faq_items || translations.en.faq_items;

  return (
    <section id="faq" className="py-20 px-4 sm:px-6 lg:px-8 bg-gradient-to-br from-slate-50 to-emerald-50">
      <div className="container mx-auto max-w-4xl">
        <div className="text-center mb-12">
          <h2 className="text-4xl sm:text-5xl font-bold text-slate-900 mb-4">
            {t('faq_title')}
          </h2>
          <p className="text-xl text-slate-600">
            {t('faq_subtitle')}
          </p>
        </div>

        <Accordion type="single" collapsible className="space-y-4">
          {faqs.map((faq, index) => (
            <AccordionItem 
              key={faq.question} 
              value={`item-${index}`}
              className="bg-white rounded-lg shadow-md border-2 border-slate-200 hover:border-amber-500 transition-colors duration-200 px-6"
            >
              <AccordionTrigger className="text-left font-semibold text-slate-900 hover:text-amber-700 py-5">
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="text-slate-700 leading-relaxed pb-5">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>

        <div className="mt-12 text-center bg-white p-8 rounded-lg shadow-lg border-2 border-amber-200">
          <p className="text-lg text-slate-700 mb-4">
            {t('faq_still_questions')}
          </p>
          <p className="text-slate-600">
            <a href="mailto:ivonne@solvidafinancial.com" className="text-emerald-700 font-bold hover:text-emerald-800">{t('faq_send_email')}</a>.
          </p>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
